<template>
<div class="catalog-left-categories">
    <ul class="catalog-left-ul">
        <li class="catalog-left-li" :style="[active == 'catalog' ? {'background' : '#e8cc0f' } : {'background': '#FFF'}]" >
            <a class="catalog-left-li-a" :rel="'nofollow'" href="/catalog/">Все</a>
        </li>
        <li class="catalog-left-li" v-for="category in categories" :class="{ active: category.id == selectedCategory?.id }" :style="[active == category.slug && !category.sub_categories?.length ? {'background' : '#e8cc0f' } : {'background': '#FFF'}]">
            <a class="catalog-left-li-a" :rel="'nofollow'" :href="'/catalog/' + category.slug" >{{ category.name }}</a>
            <ul class="cotolog-left-single-li-sub">
                <li class="catalog-left-li-sub" v-if="category?.sub_categories?.length && selectedCategory === category.slug" :style="[active == category.slug ? {'background' : '#e8cc0f' } : {'background': '#FFF'}]" >
                    <a class="catalog-left-li-sub-a" :rel="'nofollow'" :href="'/catalog/' + category.slug">Все</a>
                </li>
                <li class="catalog-left-li-sub" v-if="category?.sub_categories?.length && selectedCategory === category.slug" v-for="subCategory in category.sub_categories" :style="[active == subCategory.slug ? {'background' : '#e8cc0f' } : {'background': '#FFF'}]">
                    <a class="catalog-left-li-sub-a" :rel="'nofollow'" :href="'/catalog/mangal/' + subCategory.slug">{{ subCategory.name }}</a>
                </li>
            </ul>
        </li>
    </ul>
</div>
</template>
<script setup>
import axios from 'axios';
import { ref } from 'vue';
const selectedCategory = ref(document.location.href.split('/catalog/').reverse()[0].split('catalog/').reverse()[0].split('/')[0])
const active = ref(document.location.href.split('/catalog/').reverse()[0].split('/').reverse()[0].split('/')[0])
const categories = ref(null)
const windowWidth = ref(window.innerWidth + 'px');

async function getCategories() {
    const { data } = await axios.get('/get-categories');
    categories.value = data.categories;
}

getCategories()
</script>
<style scoped>

.catalog {
    width: 100%;
    height: auto;
    display: flex;
    gap: 15px;
    color: #3c5757;
    margin-bottom: 30px;

}

.catalog-left {
    width: 400px;
    height: auto;
    background-color: #3c5757;
    padding: 15px;
    border-radius: 0 0 8px 0;
}

.catalog-left-ul {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.catalog-left-li {
    border: 1px solid #3c5757;
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding: 4px;
    height: auto;
    min-height: 40px;
    font-size: 20px;
}

.catalog-left-li-a {
    color:#3c5757;
    &:hover {
        transform: scale(1.05);
    }
}

.cotolog-left-single-li-sub {
    /*width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;*/
    display: none;
}

.catalog-left-li-sub {
    border: 1px solid #3c5757;
    border-radius: 4px;
    padding: 4px
}

@media screen and (max-width: 1000px) {
    .catalog {
        flex-direction: column;
    }

    .catalog-left {
        width: 100%;
        border-radius: 0 0 8px 8px;
    }

    .catalog-left-ul {
        margin-top: 0;
    }
}
.catalog-left-li-sub-a, .catalog-left-li-a{
    color:#3c5757;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items:center;
}
.catalog-left-li-sub-a:hover{
    transform: scale(1.05);
}
</style>